<template lang="pug">
  v-card(flat @click="$emit('selected', item)")
    v-card-text
      v-row(no-gutters)
        v-col(cols="9")
          div.text-sm.font-semibold.neutral700--text {{ item.title }}
          div.text-xs.neutral500--text {{ item.created | convertServerDate }} &middot; {{ item.payment_method }}
        v-col.text-right
          div.text-sm(:class="displaySymbol === '+' ? 'success500--text': 'neutral700--text'") {{ displaySymbol }} {{ item.amount | displayPrice($currency) }}
    v-divider.basic300(v-if="index !== totalItems")
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    }
  },
  computed: {
    displaySymbol() {
      return this.item.type === 'Wallet' ? '+' : '-'
    }
  }
}
</script>

<style scoped>
</style>